export const isLocalHost = (): boolean => location.hostname === 'localhost';
